module.exports = __webpack_public_path__ + "img/diogo.333e796d.jpeg";